/**
 * Programs Translations Module (Spanish)
 * @module programs
 * @language es
 */

export const programs = {
  programsEventsPage: { pageSubtitle: "JCI RISE • CYE • JIB • Debate • Oratoria • Conferencias 2024-2025" },
  programs: {
    flagshipPrograms: "Programas Insignia",
    programDataMetrics: "Datos de impacto real del Informe de Impacto JCI 2025",
    coreInitiative: "Iniciativa Principal",
    jciRise: "JCI RISE",
    riseQuote: "Reconstruyendo comunidades, Inspirando acción, Sosteniendo impacto, Empoderando jóvenes",
    totalProjects: "Total de Proyectos",
    beneficiaries: "Beneficiarios",
    volunteerHours: "Horas de Voluntariado",
    localOrganizations: "Organizaciones Locales",
    countries: "Países",
    projects: "proyectos",
    economicRecovery: "Recuperación Económica",
    workforceReadiness: "Preparación de la Fuerza Laboral",
    mentalHealth: "Salud Mental",
    shareOfRiseProjects: "Participación en Proyectos RISE",
    focusAreas: "Áreas de Enfoque",
    keyInitiatives: "Iniciativas Clave",
    fiiWeight: "Peso FII",
    smeSupport: "Apoyo a PYMES, microfinanzas, acceso al mercado",
    skillsTraining: "Capacitación en habilidades, programas de empleo",
    awarenessSupport: "Campañas de concientización, servicios de apoyo",
    // RISE Economic Recovery Initiatives
    businessTraining: "Capacitación empresarial",
    microfinanceLinkage: "Vinculación con microfinanzas",
    marketAccess: "Acceso al mercado",
    // RISE Workforce Initiatives
    stemTraining: "Capacitación STEM",
    digitalSkills: "Habilidades digitales",
    apprenticeships: "Pasantías",
    // RISE Mental Health Initiatives
    supportGroups: "Grupos de apoyo",
    schoolWellnessPrograms: "Programas de bienestar escolar",
    hotlines: "Líneas de ayuda",
    // FII Weight Labels
    entrepreneurship: "emprendimiento",
    workforce: "fuerza laboral",
    mentalHealthWeight: "salud mental",
    regionalProjectDistribution: "Distribución Regional de Proyectos",
    largestVolume: "Mayor Volumen",
    rapidGrowth: "Crecimiento Rápido",
    consolidating: "Consolidando",
    qualityFocus: "Enfoque en Calidad",
    strategicOpportunity: "Oportunidad Estratégica",
    strategicOpportunityText: "América y Europa representan solo el 11% de proyectos pero tienen fuerte infraestructura para RISE. Considere expansión dirigida.",
    sdgAlignmentMatrix: "Matriz de Alineación ODS",
    sdgsAddressed: "12 ODS Abordados",
    riseProjectsAddress: "Proyectos RISE abordan 12 de los 17 ODS de la ONU",
    primaryFocusAreas: "Áreas de Enfoque Primarias",
    allSdgsCoverage: "Cobertura de Todos los ODS",
    primaryFocus: "Enfoque Primario",
    crossCutting: "Transversal",
    sizeProjectCount: "Conteo de Proyectos",
    resourcesMobilized: "Recursos Movilizados",
    total: "Total",
    totalResourceMobilization: "Movilización Total de Recursos",
    estimatedValue: "Valor económico estimado generado",
    resourceBreakdown: "Desglose de Recursos",
    volunteer: "Valor del Voluntariado",
    volunteerHoursValue: "Valor de Horas de Voluntariado",
    corporate: "Socios Corporativos",
    corporatePartnerships: "Asociaciones Corporativas",
    grantsFoundations: "Subvenciones y Fundaciones",
    hoursAtStandardRate: "435,605 horas a tasa estándar",
    hoursAtStandardRates: "horas a tasas estándar",
    globalCorporatePar: "Asociaciones corporativas globales",
    globalCorporatePartners: "Socios corporativos globales",
    foundationSupport: "Apoyo de fundaciones y subvenciones",
    efficiencyMetrics: "Métricas de Eficiencia",
    costPerBeneficiary: "Costo por Beneficiario",
    volunteerROI: "ROI del Voluntariado",
    partnerRetention: "Retención de Socios",
    highlyEfficient: "Altamente Eficiente",
    forEveryDollar: "Por cada dólar invertido",
    yearOverYear: "Año tras año",
    virtualEvent: "Evento Virtual",
    globalYouthDialogue: "Diálogo Global de la Juventud",
    dialogueDate: "24 de Septiembre de 2025",
    theme: "Tema",
    youthLeadershipUncertainty: "Liderazgo Juvenil en Tiempos de Incertidumbre",
    globalYouthLeaders: "Líderes Jóvenes Globales",
    continents: "Continentes",
    registrants: "Registrados",
    liveAttendees: "Participantes en Vivo",
    fbLiveViewers: "Espectadores FB Live",
    totalReach: "Alcance Total",
    comments: "Comentarios",
    shares: "Compartidos",
    reactions: "Reacciones",
    eventOutcomes: "Resultados del Evento",
    leadershipTrainingHours: "Horas de Capacitación en Liderazgo",
    certificatesIssued: "Certificados Emitidos",
    businessPartnerships: "Asociaciones de Negocios",
    mentorshipRelationships: "Relaciones de Mentoría",
    riseProjectsCommissioned: "Proyectos RISE Comisionados",
    mediaImpressions: "Impresiones de Medios",
    genderDistribution: "Distribución de Género",
    male: "Masculino",
    female: "Femenino",
    nonBinary: "No Binario",
    attendanceType: "Tipo de Asistencia",
    events20242025: "Eventos 2024-2025",
    repeatAttendees: "Asistentes Recurrentes",
    firstTime: "Primera Vez",
    firstTimeRecruitment: "¡Oportunidad clave de reclutamiento!",
    conferencesMap: "Mapa de Conferencias",
    areaConferencesWorldCongress: "Conferencias de Área y Congreso Mundial",
    events: "Eventos",
    resetView: "Restablecer Vista",
    worldCongress: "Congreso Mundial",
    areaConference: "Conferencia de Área",
    expected: "esperado",
    openInGoogleMaps: "Abrir en Google Maps",
    participants: "participantes",
    teams: "equipos",
    prizeMoney: "Premio en Efectivo",
    largest: "Mayor",
    top: "Top",
    impact: "Impacto",
    winnerProfile: "Perfil del Ganador",
    averageAge: "Edad Promedio",
    femaleFounders: "Fundadoras Femeninas",
    participationByConference: "Participación por Conferencia",
    curriculumAreas: "Áreas del Currículo",
    outcomes: "Resultados",
    partnerNetwork: "Red de Socios",
    new: "NUEVO",
    learnMore: "Saber Más",
    lessDetails: "Menos Detalles"
  },
  programDetailData: {
    cyeObjective: "Desarrollando jóvenes emprendedores a través de competencias de innovación",
    cyeImpact1: "108 emprendedores de 20+ países compitieron",
    cyeImpact2: "Más de $10,000 en premios otorgados",
    cyeImpact3: "35% de participantes fueron fundadoras femeninas",
    cyeImpact4: "40% en sector tecnológico, diversificando industrias",
    cyeImpact5: "Conexiones de mentoría y networking establecidas",
    services: "Servicios",
    other: "Otro",
    cyeGeography: "Distribución global en las 4 áreas JCI",
    cyeFiiAlignment: "Apoya dimensiones de recuperación económica y emprendimiento del FII",
    jibObjective: "Desarrollo profesional y networking de negocios",
    jibCurriculum1: "Innovación y Estrategia de Negocios",
    jibCurriculum2: "Gestión Financiera",
    jibCurriculum3: "Acceso al Mercado Global",
    jibCurriculum4: "Excelencia en Liderazgo",
    jibCurriculum5: "Salud Mental en los Negocios",
    jibOutcome1: "Reportaron habilidades de negocios mejoradas",
    jibOutcome2: "Expandieron red profesional",
    jibOutcome3: "Lanzaron nuevas iniciativas de negocios",
    jibOutcome4: "Aumentaron confianza en liderazgo",
    jibOutcome5: "Aplicaron prácticas de bienestar mental",
    growingRapidly: "Creciendo Rápidamente",
    globalMentors: "Mentores Globales",
    angelInvestors: "Inversionistas Ángel",
    vcNetworks: "Redes de VC",
    jibFiiAlignment: "Se alinea con dimensiones de fuerza laboral y económicas del FII",
    fiiAlignment: "Alineación FII",
    publicSpeakingName: "Competencia de Oratoria",
    publicSpeakingObjective: "Desarrolla confianza y excelencia en comunicación",
    psTopic1: "Juventud y Acción Climática",
    psTopic2: "Liderazgo en la Incertidumbre",
    psTopic3: "Impacto de la Transformación Digital",
    psTopic4: "Construcción de Resiliencia Comunitaria",
    psSkill1: "Comunicación Verbal",
    psSkill2: "Pensamiento Crítico",
    psSkill3: "Construcción de Confianza",
    psSkill4: "Conciencia Intercultural",
    psSkill5: "Presencia de Liderazgo",
    reportIncreasedConfidence: "reportan aumento de confianza",
    equalParticipation: "Participación Igual",
    psFiiAlignment: "Mejora preparación laboral a través de habilidades de comunicación",
    debatingName: "Campeonato de Debate",
    debatingObjective: "Competencia de debate multilingüe promoviendo pensamiento crítico",
    english: "Inglés",
    french: "Francés",
    spanish: "Español",
    debateSkill1: "Razonamiento Analítico",
    debateSkill2: "Argumentación Estructurada",
    debateSkill3: "Habilidades de Investigación",
    debateSkill4: "Conciencia Global",
    debateSkill5: "Excelencia Académica",
    debateFormat: "Formato de Debate de Escuelas Mundiales",
    debateFiiAlignment: "Desarrolla pensamiento crítico para preparación laboral",
    debateImpact1: "Pensamiento analítico mejorado",
    debateImpact2: "Oratoria mejorada",
    debateImpact3: "Habilidades de metodología de investigación",
    debateImpact4: "Comprensión intercultural"
  },
  sdgs: {
    noPoverty: "Fin de la Pobreza",
    zeroHunger: "Hambre Cero",
    goodHealth: "Buena Salud y Bienestar",
    qualityEducation: "Educación de Calidad",
    genderEquality: "Igualdad de Género",
    cleanWater: "Agua Limpia y Saneamiento",
    affordableEnergy: "Energía Asequible y No Contaminante",
    decentWork: "Trabajo Decente y Crecimiento Económico",
    industryInnovation: "Industria, Innovación e Infraestructura",
    reducedInequalities: "Reducción de las Desigualdades",
    sustainableCities: "Ciudades y Comunidades Sostenibles",
    responsibleConsumption: "Producción y Consumo Responsables",
    climateAction: "Acción por el Clima",
    lifeBelowWater: "Vida Submarina",
    lifeOnLand: "Vida de Ecosistemas Terrestres",
    peaceJustice: "Paz, Justicia e Instituciones Sólidas",
    partnerships: "Alianzas para los Objetivos"
  },
  programsShowcase: { title: "Programas y Eventos Insignia", subtitle: "Datos de impacto real del Informe de Impacto JCI 2025", coreInitiative: "Iniciativa Principal", riseDesc: "Reconstruyendo, Inspirando, Sosteniendo y Empoderando comunidades", projects: "Proyectos", beneficiaries: "Beneficiarios", volunteerHours: "Horas de Voluntariado", risePillarsDistribution: "Distribución de Pilares RISE", economicRecovery: "Recuperación Económica", workforceReadiness: "Preparación de la Fuerza Laboral", mentalHealth: "Salud Mental", cye: "Creative Young Entrepreneur (CYE)", cyeDesc: "Competencia regional de emprendimiento", jib: "JCI in Business (JIB)", jibDesc: "Programa de networking y desarrollo de negocios", publicSpeaking: "Competencia de Oratoria", publicSpeakingDesc: "Desarrolla confianza y habilidades de comunicación", debating: "Campeonato de Debate", debatingDesc: "Competencia de debate multilingüe", english: "Inglés", french: "Francés", spanish: "Español", totalParticipants: "Total de Participantes", totalTeams: "Total de Equipos", prize: "Premio", teams: "equipos", areaConferences2025: "Conferencias de Área 2025", asiaPacificConference: "Conferencia Asia-Pacífico", europeConference: "Conferencia Europa", africaMeConference: "Conferencia África & ME", americasConference: "Conferencia Américas", attendees: "Asistentes", firstTimers: "primerizos", featuredEvent: "Evento Destacado", globalYouthDialogue: "Diálogo Global de la Juventud 2025", registrants: "Registrados", liveAttendees: "Participantes en Vivo", fbLiveViewers: "Espectadores FB Live", chatMessages: "Mensajes de Chat", jciSenators: "Senadores JCI", senatorsNew: "84 nuevos en 2025", toypRecognized: "TOYP Reconocido", toypCategories: "10 categorías", peopleImpacted: "Personas Impactadas", throughAllPrograms: "A través de todos los programas", sourceNote: "Informe de Impacto JCI 2025 - Datos oficiales de programas y eventos" },
  sdgAlignment: { title: "Alineación ODS", subtitle: "Programas JCI mapeados a Objetivos de Desarrollo Sostenible de la ONU", sdgCount: "ODS Cubiertas", sdgCountDesc: "Programas JCI contribuyen a 12 de los 17 ODS de la ONU", primaryGoals: "Objetivos Principales", primaryGoalsDesc: "Más impactados por las iniciativas JCI", goodHealth: "Buena Salud y Bienestar", qualityEducation: "Educación de Calidad", decentWork: "Trabajo Decente y Crecimiento Económico", reducedInequalities: "Reducción de Desigualdades", partnerships: "Alianzas para los Objetivos", impactMapping: "Mapeo de Impacto", riseProjects: "Proyectos RISE", riseProjectsDesc: "Alineado con salud mental, fuerza laboral y recuperación económica", cyeProgram: "Programa CYE", cyeDesc: "Apoya emprendimiento e innovación", jibProgram: "Programa JIB", jibDesc: "Fomenta habilidades de negocios y redes profesionales", toyp: "TOYP", toypDesc: "Reconoce liderazgo e impacto juvenil", sourceNote: "Fuente: Informe de Impacto JCI 2025 - Metodología de alineación ODS" },
  impactMetricsTitle: "Métricas de Impacto",
  impactMetricsSubtitle: "Midiendo el alcance global de JCI e impacto comunitario",
  riseTitle: "Iniciativa RISE",
  riseSubtitle: "Reconstruyendo, Inspirando, Sosteniendo y Empoderando comunidades",
  cyeTitle: "Creative Young Entrepreneurs (CYE)",
  cyeSubtitle: "Competencia regional de emprendimiento",
  jibTitle: "JCI in Business (JIB)",
  jibSubtitle: "Networking de negocios y desarrollo profesional",
  debatingTitle: "Campeonato de Debate",
  debatingSubtitle: "Competencia de debate multilingüe fomentando pensamiento crítico",
  publicSpeakingTitle: "Competencia de Oratoria",
  publicSpeakingSubtitle: "Desarrollando confianza y habilidades de comunicación",
  conferencesTitle: "Conferencias de Área",
  conferencesSubtitle: "Encuentros regionales anuales para networking y capacitación",
  rise: { title: "Iniciativa JCI RISE", subtitle: "Reconstruyendo, Inspirando, Sosteniendo y Empoderando comunidades", totalProjects: "Total de Proyectos RISE", beneficiariesReached: "Beneficiarios Alcanzados", volunteerHours: "Horas de Voluntariado", budgetMobilized: "Presupuesto Movilizado", pillarDistribution: "Distribución de Pilares", mentalHealth: "Salud Mental", workforceReadiness: "Preparación de la Fuerza Laboral", economicRecovery: "Recuperación Económica", regionalBreakdown: "Desglose Regional", projectsByRegion: "Proyectos por Región", topProjects: "Principales Proyectos RISE por Impacto", viewFullReport: "Ver Informe RISE Completo" },
  cye: { title: "Creative Young Entrepreneurs (CYE)", subtitle: "Competencia regional de emprendimiento fomentando innovación", participants: "Total de Participantes", teams: "Total de Equipos", prizePool: "Pool Total de Premios", winnersTitle: "Ganadores 2024", categories: "Categorías de Competencia", socialEnterprise: "Empresa Social", techInnovation: "Tecnología e Innovación", greenBusiness: "Negocio Verde", traditionalBusiness: "Negocio Tradicional", impactMetrics: "Métricas de Impacto", businessesLaunched: "Negocios Lanzados", jobsCreated: "Empleos Creados", fundingSecured: "Financiamiento Asegurado" },
  jib: { title: "JCI in Business (JIB)", subtitle: "Desarrollo profesional y programa de networking de negocios", activeMembers: "Miembros JIB Activos", networkingEvents: "Eventos de Networking", businessPartnerships: "Asociaciones de Negocios", benefits: "Beneficios JIB", professionalNetwork: "Acceso a red profesional", businessSkills: "Desarrollo de habilidades de negocios", mentorship: "Oportunidades de mentoría", careerAdvancement: "Apoyo al avance de carrera", focusAreas: "Áreas de Enfoque", leadership: "Desarrollo de Liderazgo", networking: "Networking de Negocios", skills: "Habilidades Profesionales", entrepreneurship: "Apoyo al Emprendimiento" },
  debating: { title: "Campeonato de Debate JCI", subtitle: "Competencia de debate multilingüe promoviendo pensamiento crítico", totalTeams: "Total de Equipos", languages: "Idiomas", countries: "Países Participantes", format: "Formato de Competencia", preliminaryRounds: "Rondas Preliminares", semifinals: "Semifinales", grandFinal: "Gran Final", skillsDeveloped: "Habilidades Desarrolladas", criticalThinking: "Pensamiento Crítico", publicSpeaking: "Oratoria", research: "Investigación y Análisis", teamwork: "Trabajo en Equipo y Colaboración", recentChampions: "Campeones Recientes", viewHighlights: "Ver Momentos del Debate" },
  publicSpeaking: { title: "Competencia de Oratoria", subtitle: "Construyendo confianza y excelencia en comunicación", participants: "Total de Participantes", countries: "Países Participantes", speechTopics: "Temas de Discurso", improvisation: "Discurso Improvisado", prepared: "Discurso Preparado", persuasive: "Discurso Persuasivo", competencies: "Competencias Evaluadas", delivery: "Entrega y Presencia", content: "Contenido y Estructura", impact: "Impacto y Persuasión", languageProficiency: "Dominio del Idioma", recentWinners: "Ganadores Recientes", watchSpeeches: "Ver Discursos Ganadores" },
  conferences: { title: "Conferencias de Área JCI", subtitle: "Encuentros regionales anuales para networking, capacitación y liderazgo", totalAttendees: "Total de Asistentes (2025)", conferences: "Conferencias", firstTimers: "Asistentes por Primera Vez", countries: "Países Representados", conferenceHighlights: "Momentos de la Conferencia", keynotes: "Oradores Principales", workshops: "Talleres de Capacitación", networking: "Sesiones de Networking", awards: "Premios y Reconocimiento", upcomingConferences: "Próximas Conferencias 2025", registerNow: "Regístrese Ahora", viewSchedule: "Ver Programa" },
  toyp: { title: "Ten Outstanding Young Persons (TOYP)", subtitle: "Reconociendo líderes jóvenes excepcionales mundialmente", recognizedLeaders: "Líderes Reconocidos (2025)", categories: "Categorías de Premio", nominationsOpen: "Período de Nominaciones", categoryList: { businessEconomic: "Logro Empresarial y Económico", humanitarian: "Servicio Humanitario y Voluntario", science: "Liderazgo y Logro Académico", political: "Asuntos Políticos, Legales y Gubernamentales", cultural: "Logro Cultural", medical: "Innovación Médica", environmental: "Liderazgo Ambiental", world: "Paz Mundial y Derechos Humanos", children: "Bienestar y Educación Infantil", personal: "Mejora y Logro Personal" }, selectionProcess: "Proceso de Selección", nomination: "Nominación", evaluation: "Evaluación", recognition: "Reconocimiento", pastHonorées: "Homenajeados TOYP Anteriores", submitNomination: "Enviar Nominación" },
  programMetrics: { title: "Métricas de Participación en Programas", subtitle: "Compromiso de miembros en programas JCI", totalParticipants: "Total de Participantes del Programa", programReach: "Alcance del Programa por Región", growthTrend: "Crecimiento Año tras Año", satisfactionScore: "Satisfacción del Participante", highRating: "Alta Calificación", repeatParticipation: "Participación Repetida", likelyToRecommend: "Probabilidad de recomendar", topPerformingPrograms: "Programas de Mejor Desempeño", program: "Programa", participants: "Participantes", satisfaction: "Satisfacción", growth: "Crecimiento" },
  programImpact: { title: "Evaluación de Impacto del Programa", subtitle: "Midiendo resultados e impacto a largo plazo", skillsDevelopment: "Desarrollo de Habilidades", reportImprovedSkills: "Reportan habilidades de liderazgo mejoradas", networkGrowth: "Crecimiento de Red", expandedNetwork: "Expandieron red profesional", careerAdvancement: "Avance de Carrera", careerProgress: "Atribuyen progreso de carrera a JCI", communityImpact: "Impacto Comunitario", ledCommunityProjects: "Lideraron o participaron en proyectos comunitarios", impactStories: "Historias de Impacto", readStories: "Leer Historias de Miembros", shareYourStory: "Comparta Su Historia" },
  humanDuties: {
    title: "Iniciativa Internacional de Deberes Humanos",
    headline: "67,101 Voces Globales por el Liderazgo Ético",
    heroDescription: "La Iniciativa Internacional de Deberes Humanos representa un cambio fundamental en el discurso global de liderazgo. Mientras los derechos humanos son ampliamente reconocidos, el concepto complementario de deberes humanos permanece poco explorado. JCI lidera esta conversación a través de la Declaración Universal de Deberes Humanos para Líderes.",
    totalPetitions: "Total de Peticiones Firmadas",
    globalSignatories: "signatarios globales",
    geographicCoverage: "Cobertura Geográfica",
    countriesAcross: "países en 4 regiones",
    nationalAmbassadors: "Embajadores Nacionales",
    leadingCoordination: "liderando coordinación IHDD",
    regionalBreakdown: "Desglose Regional",
    region: "Región",
    petitionsSigned: "Peticiones Firmadas",
    percentGlobal: "% del Global",
    asiaPacific: "Asia y el Pacífico",
    africaMiddleEast: "África y Oriente Medio",
    americas: "América",
    europe: "Europa",
    highMomentum: "Alto momentum",
    growingActivities: "Creciendo (19 actividades)",
    establishedBase: "Base establecida",
    emerging: "Emergente",
    keyMilestones: "Hitos Institucionales Clave",
    nelsonMandelaEndorsement: "Respaldo de la Fundación Nelson Mandela",
    mandelaDesc: "Reconocimiento oficial de la Iniciativa de Deberes Humanos (2025)",
    legislativeSuccess: "Éxito Legislativo",
    legislativeDesc: "Estado de Zulia (Venezuela) promulgó Ley de Deberes Humanos, declaró el 10 de julio como Día Internacional de los Deberes Humanos (2025)",
    ihddImpact: "Impacto del Día Internacional de los Deberes Humanos (IHDD)",
    reportedActivities: "Actividades Reportadas 2025",
    sevenDutiesFramework: "Los 7 Deberes para Líderes",
    duty1: "Deber de Defender la Dignidad Humana",
    duty2: "Deber de Servir al Bien Común",
    duty3: "Deber de Proteger el Medio Ambiente",
    duty4: "Deber de Promover Equidad y Justicia",
    duty5: "Deber de Fomentar Paz y Entendimiento",
    duty6: "Deber de Apoyar Educación y Desarrollo",
    duty7: "Deber de Actuar con Integridad y Responsabilidad",
    ctaTitle: "Sé Parte del Movimiento",
    signPetition: "Firma la Petición",
    becomeAmbassador: "Conviértete en Embajador Nacional",
    viewStories: "Ver Historias IHDD",
    sourceNote: "Fuente: Informe de Impacto JCI 2025 – Datos de Iniciativa de Deberes Humanos"
  },
  strategicPartnerships: {
    title: "Alianzas Estratégicas Globales",
    headline: "Construyendo Puentes: Alianzas Estratégicas Globales de JCI",
    heroDescription: "El impacto de JCI se amplifica a través de alianzas estratégicas con organizaciones globales que comparten nuestro compromiso de desarrollar jóvenes líderes y avanzar el desarrollo sostenible.",
    activePartnership: "Alianza activa",
    growingPartnership: "Alianza en crecimiento",
    emergingPartnership: "Alianza emergente",
    infrastructurePartner: "Socio de infraestructura",
    partnershipTiers: "Niveles de Alianza",
    tier1Active: "Nivel 1: Alianzas Activas",
    tier2Growing: "Nivel 2: Alianzas en Crecimiento",
    tier3Emerging: "Nivel 3: Alianzas Emergentes",
    tier4Infrastructure: "Nivel 4: Socios de Infraestructura",
    roiIndicators: "Indicadores de ROI de Alianza",
    partner: "Socio",
    memberBenefit: "Beneficio para Miembros",
    orgBenefit: "Beneficio Organizacional",
    effortLevel: "Nivel de Esfuerzo",
    roiTimeline: "Cronograma de ROI",
    low: "Bajo",
    medium: "Medio",
    veryLow: "Muy Bajo",
    immediate: "Inmediato",
    threeMonths: "3 meses",
    sixMonths: "6 meses",
    oneYear: "1 año",
    iccName: "Cámara de Comercio Internacional (ICC)",
    unName: "Naciones Unidas (ONU)",
    unescoName: "UNESCO",
    worldBankName: "Banco Mundial / IFC",
    wefName: "Foro Económico Mundial (WEF)",
    aiesecName: "AIESEC",
    bniName: "BNI (Business Network International)",
    wbafName: "Foro de Alianza de Mujeres de Negocios (WBAF)",
    zohoName: "Zoho",
    gyefName: "Foro Económico Global de la Juventud (GYEF)",
    ctaTitle: "Únete a la Red de Alianzas",
    viewAllPartnerships: "Ver Todas las Alianzas",
    partnerWithJCI: "Alianza con JCI",
    accessResources: "Acceder a Recursos de Socios",
    sourceNote: "Fuente: Informe de Impacto JCI 2025 – Alianzas Estratégicas"
  }
} as const;
